/// <amd-module name="Test/TestPlansHubRefresh/TestPlansSegment/Redux/TestPlansSegmentReducer" />
import { default as produce } from "immer";
import { ITestPlansSegmentState } from "./TestPlansSegmentContracts";
import { TestPlansSegmentActions, TestPlansSegmentActionsTypes } from "./TestPlansSegmentActions";

/**
 * TestPlanSegmentReducer: Reducer for test plan segment for favorites and navigate back to mine/all page.
 */
export function TestPlansSegmentReducer(state: ITestPlansSegmentState, action: TestPlansSegmentActions): ITestPlansSegmentState {
    state = state || ({} as ITestPlansSegmentState);

    return produce(state, (draftState: ITestPlansSegmentState) => {
        switch (action.type) {
            case TestPlansSegmentActionsTypes.updateFavoriteStatus:
                draftState.isFavorited = action.payload.favoriteStatus;
                if (action.payload.favoriteId) {
                    draftState.favoriteId = action.payload.favoriteId;
                } else {
                    draftState.favoriteId = undefined as any;
                }
                break;

            case TestPlansSegmentActionsTypes.updateFavoritePlansList:
                draftState.favoritePlans = action.payload.favorites;
                break;

            case TestPlansSegmentActionsTypes.updateTestPlanProgressSummary:
                draftState.testPlanProgressSummary = action.payload.testPlanProgressSummary;
                break;

            default:
                break;
        }
    });
}
